export const useResizedPx = (pxValue = 0) => {
  const resizedPxValue = ref(pxValue);

  function setResizedPxValue() {
    resizedPxValue.value = toResizedPx(pxValue);
  }

  onMounted(() => {
    setResizedPxValue();
    useEventListener('resize', setResizedPxValue);
  });

  return resizedPxValue;
};
